import { createSlice } from '@reduxjs/toolkit';

const productModalSlice = createSlice({
  name: 'productModal',
  initialState: {
    isOpen: false,
    productData: null,
  },
  reducers: {
    // Reducer to open modal and to get product data to display
    openModal: (state, action) => {
      state.isOpen = true;
      state.productData = action.payload;
    },
    // Reducer to close modal and remove product data
    closeModal: (state) => {
      state.isOpen = false;
      state.productData = null;
    },
  },
});

export const { openModal, closeModal } = productModalSlice.actions;

export default productModalSlice.reducer;
